import React from 'react';
import { Link } from '@zola/zola-ui';
import { connect } from 'react-redux';

// import { trackRecommendation } from '../../../../../../util/trackingHelper';

const SeeSamplePageLink = ({ themeKey, ...props }) => {
  const trackClick = () => {
    // trackRecommendation('Clicked', {});
  };

  if (!themeKey) return null;

  return (
    <Link
      {...props}
      arrow
      size="small"
      onClick={trackClick}
      href={`/wedding/sample-${themeKey}/registry`}
      target="_blank"
      rel="noopener noreferrer"
    >
      See a Sample Page
    </Link>
  );
};

const mapStateToProps = state => ({
  themeKey: state.wedding.theme.key,
});

export default connect(mapStateToProps)(SeeSamplePageLink);



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/RegistryContainer/components/SeeSamplePageLink.jsx